import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { PaginatedColocApiConnectedDropDown } from '@/features/shared/feature-paginated-coloc-api-connected-dropdown';

import { City } from '@/types/admin';
import { useGetCitiesInfinite } from '@/features/shared/hooks/use-get-cities-infinite';
import { useStatsFiltersContext } from '../../hooks/use-stats-filters';

const StatsCitySelectionDropDown = () => {
  const { selectedCity, setSelectedCity, citiesQuery, setCitiesQuery } = useStatsFiltersContext();
  const { t } = useTranslation();

  return (
    <PaginatedColocApiConnectedDropDown<City>
      placeholder={t('js.features.admin.stats.dashboard.city_selection.placeholder')}
      className="z-50 w-[200px]"
      showLabel
      label={t('js.features.admin.stats.dashboard.city_selection.label')}
      value={selectedCity}
      onChange={setSelectedCity}
      {...(selectedCity && {
        displayValue: selectedCity.name,
      })}
      onTextInputChange={(event) => setCitiesQuery(event.target.value)}
      dataSource={
        useGetCitiesInfinite({
          searchQuery: citiesQuery,
        })!
      }
      itemRenderer={(itemProps, ref) => {
        return (
          // @ts-ignore
          <DropDown.DropDownOptionDefaultContent
            ref={ref}
            className="font-['sofia-pro'] text-sm font-normal leading-[21px] text-[#212529]"
          >
            {itemProps.name}
          </DropDown.DropDownOptionDefaultContent>
        );
      }}
    />
  );
};

export { StatsCitySelectionDropDown };
